module.exports = __webpack_public_path__ + "static/footer-gw-logo-9ff4a85df6cd7f0010d9b0e01b619a60.svg";